import React from 'react';
import AnsweredComponent
  from '../../components/answeredComponent/AnsweredComponent';

const Answered = () => {
  return (
    <div>
      <AnsweredComponent />
    </div>
  );
};

export default Answered;
